import { apiPublic } from "./apiPublic.service";

const API_URL = "/locations";

class LocationService {
    async getRegions(query) {
        try {
            if (!query || query.length < 2) {
                return [];
            }
            const response = await apiPublic.get(`${API_URL}/regions`, { params: { q: query } });
            return response.data;
        } catch (error) {
            console.error("Error fetching regions:", error);
            throw error;
        }
    }

    async getDepartments(query) {
        try {
            if (!query || query.length < 2) {
                return [];
            }
            const response = await apiPublic.get(`${API_URL}/departments`, { params: { q: query } });
            return response.data;
        } catch (error) {
            console.error("Error fetching departments:", error);
            throw error;
        }
    }

    async getDepartmentById(departmentId) {
        try {
            const response = await apiPublic.get(`${API_URL}/departments/${departmentId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching department by ID:", error);
            throw error;
        }
    }

    async getCities(query) {
        try {
            if (!query || query.length < 2) {
                return [];
            }
            const response = await apiPublic.get(`${API_URL}/cities`, { params: { q: query } });
            return response.data;
        } catch (error) {
            console.error("Error fetching cities:", error);
            throw error;
        }
    }

    async getCityById(cityId) {
        try {
            const response = await apiPublic.get(`/locations/cities/${cityId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching city by ID:", error);
            throw error;
        }
    }
}

export default new LocationService();